import mutations from './mutations';
import getters from './getters';
import actions from './actions';

export default {
  namespaced: true,
  state: {
    clinicId: null,
    documents: [],
    isLoading: false,
    query: '',
  },
  actions,
  getters,
  mutations,
};
